export enum DomainStatus {
    PENDING = "pending",
    VERIFICATION_REQUIRED = "verification_required",
    VERIFYING = "verifying",
    VERIFIED = "verified",
    PROVISIONING = "provisioning",
    ACTIVE = "active",
    FAILED = "failed",
    REMOVING = "removing",
    REMOVED = "removed",
}

export enum SSLStatus {
    PENDING = "pending",
    ISSUING = "issuing",
    ISSUED = "issued",
    FAILED = "failed",
    EXPIRED = "expired",
}

export interface DNSRecord {
    type: string;
    name: string;
    value: string;
}
export interface DNSInstructions {
    verification: DNSRecord;
    routing: DNSRecord;
}

export interface CustomDomainListData {
    id: number;
    hostname: string;
    status: DomainStatus;
    verification_token: string;
    ssl_status: SSLStatus;
    is_primary: boolean;
    created_at: string;
}

export interface CustomDomainDetailData extends CustomDomainListData {
    dns_instructions: DNSInstructions;
}

export interface CreateCustomDomainPayload {
    hostname: string;
}

export interface CustomDomainResponse<T> {
    data: T;
    message: string;
    status: boolean;
}

export interface CustomDomainErrorResponse<T = any> {
    status: boolean;
    message: string;
    error: T;
}


export type ResolveCustomDomainResponse<T> = Omit<
  CustomDomainResponse<T>,
  'message'
>;

export interface ResolveCustomDomainData {
    store_id: number;
    store_slug: string;
    store_name: string;
    logo_url: string | null;
}